'use client';
import { useQuery } from '@tanstack/react-query';
import { IcChevronRight, IcStarFill, Typography, theme } from '@bgzt/ui';

import { useEnvironmentInfo } from '~/hooks';
import { Spacing } from '~/components';
import { reviewStatisticsOptions } from '~/app/products/[pid]/_queries';
import { goToShopOnApp } from '~/services/app-interface';

import styles from './ReviewSummary.module.css';

type Props = {
  shopUid: number;
};
export const ReviewSummary = ({ shopUid }: Props) => {
  const { isWebview } = useEnvironmentInfo();
  const { data: reviewData } = useQuery(reviewStatisticsOptions(shopUid));

  const handleClick = () => {
    if (!isWebview) return;
    goToShopOnApp({ uid: shopUid }).go();
  };

  return (
    <>
      <Spacing height={4} />

      <div className={styles.container} onClick={handleClick}>
        <Typography as="div" variant="L12" color={'gray-600'}>
          <span>
            <IcStarFill size={9.9} fill={theme.colors['yellow-500']} className={styles.star} />
            {reviewData?.averageGrade ?? '-'}
            ・거래후기 {reviewData?.reviewCount.toLocaleString() ?? '-'}
            ・만족도 {reviewData?.goodReviewPercentage ?? '-'}%
          </span>
        </Typography>
        <IcChevronRight size={10} fill={theme.colors['gray-500']} className={styles.chevronRight} />
      </div>
    </>
  );
};
